import React from 'react';

export default function OptionPill(props) {

    const onClick = () => {
        props.onClick(props.option)
    }

    const classes = Classes('option', 'pill', {
        'highlighted': props.isHighlighted
    });

    const valueClasses = Classes('ui5-pillbox s26', 'w200', {
        ['gd-c-bgp-'+props.option.color]        : !!props.option.color,
        ['gd-c-pale-border-'+props.option.color]: !!props.option.color,
    })

    return (
        <div className={classes} onClick={onClick}>
            <div className={valueClasses}>{props.option.label}</div>
        </div>
    )
}